import { TradingEventsPort } from '../ports/trading-events.port';
import { InjectionToken } from '@angular/core';

export const TRADING_EVENTS_TOKEN = new InjectionToken<TradingEventsPort>('TradingEventsPort');
